import { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import utility from 'src/utils/utility'
import ApiContext from 'src/provider/API/call-service'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { Button, CustomContainer, FlexRow, PageTitle, PageWrapper } from 'src/style'
import { Filter, ServerSideTable } from 'src/component'
import { usersColumns } from 'src/utils/table-layout'
import helpers from 'src/utils/helpers'
import { Create_Edit_InstitutionUser } from 'src/popup'
import { UserType } from 'src/model'


const InstitutionUsers = () => {
    const navigate = useNavigate()
    const {API, downloadReport} = useContext(ApiContext)
    const {setInfoProperty} = useContext(AppInfoContext)
    const [reportData, setReportData] = useState<any>(null)
    const [report, setReport] = useState<any>(null)
    const [resetPagination, setResetPagination] = useState<boolean>(false)
    const [view, setView] = useState<string>('')
    
    const filterDataRef = useRef({})

    useEffect(() => {
        filterDataRef.current = {}
        handleFetchReport()
    }, [])

    async function handleFetchReport(pageNumber = 1, pageSize = 10, isDownload = false, sortOrder: string = 'desc', sortColumn: string = 'id') {
        const requestBody = {
            pageNumber,
            pageSize,
            sortOrder,
            sortColumn,
            filter: {
                userType: UserType.CLIENT
            }
        }

        const response = await API.getUserByUserType(requestBody);

        if (response) {
            if (isDownload) {
                return downloadReport(response, 'USERS_REPORT')
            }

            response.data = helpers.addSerialNumberToItems(response?.data, { pageNumber, pageSize })

            setReportData(response)
            setReport(response.data)
        }
    }

    function handleClear () {
        filterDataRef.current = {}
        handleFetchReport()
        setResetPagination(!resetPagination)
    }

    async function handleSelectedUser (data: any) {
        await setInfoProperty('selectedUser', data)
        await setInfoProperty('profileTypeAccess', 'report')
        navigate('/general/users/user-profile')
    }

    return (
        <>
            <PageWrapper>
                <CustomContainer topMargin='2.5'>
                    <FlexRow 
                        justifyContent='space-between' alignItems='flex-start' 
                        bottomMargin='1.5' gap='1.5' wrap='wrap'
                    >
                        <PageTitle 
                            color='#101828' textSize='3' fontWeight="500"
                        >
                            Institution Users
                        </PageTitle>
                        <Button
                            width='11.3' fontWeight="500"
                            height='4' radius='0.8' hoverColor='#0D968F'
                            hoverBgColor='#fff' borderColor='#0D968F'
                            onClick={() => setView('create-user')}
                        >
                            Create User
                        </Button>
                    </FlexRow>
                    <ServerSideTable
                        tableData={report}
                        tableColumns={usersColumns(handleSelectedUser)} 
                        dataFetchMethod={handleFetchReport}
                        totalRows={reportData?.total}
                        customStyle
                        shouldResetPagination={resetPagination}
                        canFilter={() => setView('filter')}
                        canClear={handleClear}
                        downloadAction={() => handleFetchReport(1, 10, true)}
                    />
                </CustomContainer>
            </PageWrapper>
            { view === 'create-user' &&
                <Create_Edit_InstitutionUser
                getUsers={handleFetchReport}
                    close={() => setView('')}
                />
            }
            { view === 'filter' &&
                <Filter
                    type='users'
                    onApplyFilter={handleFetchReport}
                    setFilterData={(data: any) => {filterDataRef.current = data}}
                    close={() => setView('')}
                    top='32'
                />
            }
        </>
    )
}

export default utility.routeData('users/institution', 'Institution Users', <InstitutionUsers/>)